var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockedItemRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFE6E6",
    width: 60,
    height: 60,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 25.333V24a8 8 0 1 1 16 0v1.333h2.667c.736 0 1.333.597 1.333 1.334v16c0 .736-.597 1.333-1.333 1.333H19.333A1.333 1.333 0 0 1 18 42.667v-16c0-.737.597-1.334 1.333-1.334H22zM39.333 28H20.667v13.333h18.666V28zm-10.666 7.643A2.665 2.665 0 0 1 30 30.667a2.667 2.667 0 0 1 1.333 4.976v3.024h-2.666v-3.024zm-4-10.31h10.666V24a5.333 5.333 0 0 0-10.666 0v1.333z",
    fill: "#ED2A2A",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedItemRed);
export default __webpack_public_path__ + "static/media/locked-item-red.5ff8e900fb8c57fce93e8a0565ef3379.svg";
export { ForwardRef as ReactComponent };